@if (summaryItems) {
  <div class="mb-3">
    <app-summary [model$]="model$" [summaryItems]="summaryItems.bind(this)"></app-summary>
  </div>
}

<app-grid
  stateKey="PurchaseOrderLinePurchaseOrderAllocation"
  [gridCssClass]="gridCssClass"
  [header]="header"
  [columnDefs]="columnDefs"
  [rowData]="purchaseOrderLines$ | async"
  [showDelete]="false"
  [pagination]="false"
  (rowSelected)="rowSelected($event)"
></app-grid>
